import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import HeaderCard from '../../components/Header/HeaderCard';

/**
 * L'accueil du compte sans écran de gestion (bolt 161, suite de
 * Yros/Kavero#404) : le rôle `user` reçoit cette page à la place de `Home`,
 * qui rend les totaux de paie. Aucun appel réseau — il n'y a rien à lire pour
 * un compte qui ne gère rien.
 */
function AccueilSansGestion() {
  const { t, i18n } = useTranslation();
  const dateLocale = i18n.resolvedLanguage?.startsWith('en') ? 'en-US' : 'fr-FR';
  const date = new Date().toLocaleDateString(dateLocale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="mx-auto px-2">
      <HeaderCard title={t('home.welcome')} text={t('home.todayIs', { date })} />
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 px-6 py-4">
        <h2 className="text-xl font-bold mb-2">{t('accueilSansGestion.titre')}</h2>
        <p className="text-gray-600 mb-4">{t('accueilSansGestion.texte')}</p>
        <Link to="/guide" className="text-[--color-primary] font-semibold underline">
          {t('accueilSansGestion.lienGuide')}
        </Link>
      </div>
    </div>
  );
}

export default AccueilSansGestion;
